/**
 * Types for the Tenant Sharing feature (granting/revoking another tenant READ
 * access to the caller tenant's Vector data). Pure TS — no React.
 */

/** Access scopes a tenant can grant. Only READ is supported today. */
export type ShareScope = 'READ';

/** Selectable scope options for the grant form's <Select>. */
export const SCOPE_OPTIONS: { value: ShareScope; label: string }[] = [
  { value: 'READ', label: 'READ' },
];

/** The editable "Grant access" form. */
export interface GrantForm {
  granteeTenantId: string;
  scope: ShareScope;
}

/** A fresh, empty grant form (scope defaults to READ). */
export function emptyGrantForm(): GrantForm {
  return { granteeTenantId: '', scope: 'READ' };
}

/** True when the grant form has the minimum fields to submit. */
export function isGrantFormComplete(form: GrantForm): boolean {
  return form.granteeTenantId.trim().length > 0;
}
